import { render, staticRenderFns } from "./MeldedBlock.vue?vue&type=template&id=ccc07132&scoped=true"
import script from "./MeldedBlock.vue?vue&type=script&lang=js"
export * from "./MeldedBlock.vue?vue&type=script&lang=js"
import style0 from "./MeldedBlock.vue?vue&type=style&index=0&id=ccc07132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc07132",
  null
  
)

export default component.exports